import { escapeRegularExpressionSpecialCharacters } from '.';

/**
 * Trims a specific character from the start and end of a string
 * @param stringToTrim the string to be trimmed
 * @param character the character to trim from the start/end
 * @returns Trimmed string
 */
export const trimCharacter = (stringToTrim: string, character: string) => {
  if (!character || !stringToTrim) return stringToTrim;

  if (character.length !== 1) throw new Error(`Invalid argument "${character}". Expecting a single character.`);

  character = escapeRegularExpressionSpecialCharacters(character);

  return stringToTrim.replace(new RegExp(`^${character}+|${character}+$`, 'gi'), '');
};
